/* @remove-on-es-build-begin */
// this file is not used if use https://github.com/ant-design/babel-plugin-import
// const ENV = process.env.NODE_ENV;
// if (
//   ENV !== 'production' &&
//   ENV !== 'test' &&
//   typeof console !== 'undefined' &&
//   console.warn &&
//   typeof window !== 'undefined'
// ) {
//   console.warn(
//     'You are using a whole package of fcd, ' +
//       'please use https://www.npmjs.com/package/babel-plugin-import to reduce app bundle size.',
//   );
// }
/* @remove-on-es-build-end */

import { default as MessageDrawer } from './base-components/message-drawer';
import { default as FormBuild } from './base-components/form-build';
import { default as Breadcrumb } from './base-components/breadcrumb';
import { default as Upload } from './base-components/upload';
import { default as UploadTree } from './base-components/uploadTree';
import { default as ElectronicDocument } from './base-components/electronic-document';
import { default as Icon } from './icon';
import { default as Tree } from './base-components/tree';
import { default as Modal } from './base-components/modal';
import { default as Menu } from './base-components/menu';
import { default as Table } from './base-components/table';
import { default as Form } from './base-components/form';
import { default as Header } from './base-components/header';
import { default as Drawer } from './base-components/drawer';
import { default as Steps } from './base-components/steps';
import { default as Download } from './base-components/download';
import { default as Notification } from './base-components/notification';
import { default as SpeedDials } from './base-components/speed-dials';
import { default as Base } from './base';
import { default as DatePicker } from './base-components/table/datePicker';
import { default as version } from './version';
import { default as Empty } from './base-components/empty';
import { default as EntryMenu } from './base-components/entry-menu';
import { default as FormBuildCopy } from './business-components/form-build-copy';
import Request from './request';
import ConfigProvider from './base-components/config-provider';
import directives from './directives';
import antd from 'ant-design-vue';
import { Tree as elTree } from 'element-ui';
const components = [
  Base,
  version,
  Notification,
  MessageDrawer,
  FormBuild,
  Breadcrumb,
  Upload,
  UploadTree,
  ElectronicDocument,
  Icon,
  Tree,
  Modal,
  Menu,
  Table,
  Form,
  Header,
  Drawer,
  Steps,
  EntryMenu,
  Download,
  SpeedDials,
  FormBuildCopy,
  Empty,
  DatePicker,
  ConfigProvider,
];

const install = function(Vue) {
  Vue.use(antd);
  Vue.use(elTree);
  components.map(component => {
    Vue.use(component);
  });
  window.fcdv = {
    version,
    request: Request,
  };

  Object.keys(directives).forEach(k => Vue.directive(k, directives[k]));
  // Vue.prototype.$message = message;
  Vue.prototype.$abNotification = Notification;
  // Vue.prototype.$info = Modal.info;
  // Vue.prototype.$success = Modal.success;
  // Vue.prototype.$error = Modal.error;
  // Vue.prototype.$warning = Modal.warning;
  // Vue.prototype.$confirm = Modal.confirm;
  // Vue.prototype.$destroyAll = Modal.destroyAll;
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export {
  Base,
  version,
  install,
  MessageDrawer,
  FormBuild,
  Breadcrumb,
  Upload,
  UploadTree,
  ElectronicDocument,
  Icon,
  Tree,
  Notification,
  Modal,
  Menu,
  Table,
  Form,
  Header,
  Empty,
  Drawer,
  Steps,
  EntryMenu,
  Download,
  SpeedDials,
  FormBuildCopy,
  ConfigProvider,
};

export default {
  version,
  install,
};
